import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";
import { useDashboardSettings } from "../settings/store";

const JSON_HEADERS = { "Content-Type": "application/json" };

function jsonRequest(method, payload) {
  if (payload === undefined) return { method };
  return { method, body: JSON.stringify(payload), headers: JSON_HEADERS };
}

const categoriasKeys = {
  detail(periodoId, categoriaId) {
    return ["dashboard", "categorias", "detail", { periodoId, categoriaId }];
  },
};

export function useDashboardCategoria(categoriaId) {
  const s = useDashboardSettings();
  return useQuery({
    queryKey: categoriasKeys.detail(s.periodoId, categoriaId),
    queryFn: () => api(`/dashboard/club/categorias/${categoriaId}`, {}, { periodoId: s.periodoId }),
    enabled: !!s.periodoId && !!categoriaId,
  });
}

export function useCreateDashboardCategoria() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nombre) =>
      api("/dashboard/club/categorias", jsonRequest("POST", { nombre }), { periodoId: s.periodoId }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] });
    },
  });
}

export function usePatchDashboardCategoria() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ categoriaId, patch }) =>
      api(`/dashboard/club/categorias/${categoriaId}`, jsonRequest("PATCH", patch), { periodoId: s.periodoId }),
    onSuccess: (_data, variables) => Promise.all([
      qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
      qc.invalidateQueries({ queryKey: categoriasKeys.detail(s.periodoId, variables.categoriaId) }),
      qc.invalidateQueries({ queryKey: ["dashboard", "tags"] }),
    ]),
  });
}

export function useDeleteDashboardCategoria() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (categoriaId) =>
      api(`/dashboard/club/categorias/${categoriaId}`, { method: "DELETE" }, { periodoId: s.periodoId }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] });
      qc.invalidateQueries({ queryKey: ["dashboard", "actividades"] });
    },
  });
}
